import { render, staticRenderFns } from "./dui-social-links.vue?vue&type=template&id=478c58f4&scoped=true&"
import script from "./dui-social-links.vue?vue&type=script&lang=js&"
export * from "./dui-social-links.vue?vue&type=script&lang=js&"
import style0 from "./dui-social-links.vue?vue&type=style&index=0&id=478c58f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "478c58f4",
  null
  
)

export default component.exports